import { defaultHttpClient } from '../../httpClient';
import type { PostAppleLoginRequest, PostAppleLoginResponse } from './types';

/**
 * - 애플 id_token으로 로그인하는 API (다른 소셜과 달리 access_token이 아닌 id_token 사용)
 * - 성공 시 멤버 JWT 토큰(token)을 반환한다.
 */
export const postAppleLogin = (params: PostAppleLoginRequest) => {
  return defaultHttpClient
    .request<PostAppleLoginResponse>({
      method: 'POST',
      url: '/api/v2/login/apple/',
      data: params,
    })
    .then(result => result.data);
};
